export const customDrivers = [
  { name: "Victor" },
  { name: "Junior" },
  { name: "Luis" },
  { name: "Rodrigo" },
  { name: "Belen" },
  { name: "José" },
  { name: "Carlos" },
  { name: "Ricardo" },
  { name: "Patricio" },
  { name: "No asignado" },
];

export const customProducts = [
  {
    id: "alskjhfsadfc",
    product_name: "Manga 20KG Turbo Clean",
    variation: "Lavanda",
    divisor: 20,
    matchingString: "turbocleanlavanda",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "alskjhfsadfc",
    product_name: "Manga 20KG Turbo Clean",
    variation: "Manzana",
    divisor: 20,
    matchingString: "turbocleanmanzana",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "alskjhfsadfc",
    product_name: "Manga 20KG Turbo Clean",
    variation: "Limon",
    divisor: 20,
    matchingString: "turbocleanlimon",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "alskjhfsadfc",
    product_name: "Manga 20KG Turbo Clean",
    variation: "Talco de Bebe",
    divisor: 20,
    matchingString: "turbocleantalcodebebe",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "alskjhfsadfc",
    product_name: "Manga 20KG Turbo Clean",
    variation: "Mocka",
    divisor: 20,
    matchingString: "turbocleanmocka",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Manga 20KG Easy Clean (4kg)",
    variation: "Lavanda",
    divisor: 20,
    matchingString: "easyclean4kg",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Manga 20KG Easy Clean (4kg)",
    variation: "Manzana",
    divisor: 20,
    matchingString: "easyclean4kg",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Manga 20KG Easy Clean (4kg)",
    variation: "Limon",
    divisor: 20,
    matchingString: "easyclean4kg",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Saco 20KG Easy Clean",
    variation: "Lavanda",
    divisor: 20,
    matchingString: "easyclean",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Saco 20KG Easy Clean",
    variation: "Jazmin",
    divisor: 20,
    matchingString: "easyclean",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc02937fgh0x982",
    product_name: "Saco 20KG Easy Clean",
    variation: "Manzana",
    divisor: 20,
    matchingString: "easyclean",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "mc0923gh4rc98732",
    product_name: "Mange 24KG Easy Clean (4kg)",
    variation: "Limon",
    divisor: 20,
    matchingString: "easyclean",
    prices: [
      { quantity: 1, price: 17990 },
      { quantity: 2, price: 33990 },
      { quantity: 3, price: 44990 },
      { quantity: 4, price: 17990 },
      { quantity: 5, price: 54990 },
      { quantity: 10, price: 109990 },
    ],
  },
  {
    id: "cm029o3urnmc09p2io",
    product_name: "Arena Granel (20kg)",
    divisor: 1,
    matchingString: "arenagranel",
  },
];

export const customData = [
  {
    order_id: "97",
    created_at: "2024-05-26T21:09:12.202Z",
    orderSource: "Whatsapp",
    messageRaw:
      "1 \n 05-05 \n Natalia Jimenez \n Pasaje Lago Cochranne 110 \n San Bernardo \n 945828542 \n * 40 kg trubo clean - lavanda \n * 40 kg trubo clean - manzana \n 24990 \n Tarjeta \n Super Michi \n No hay nadie desde las 15:00 en adelante",
    daily_id: "1",
    name: "Roberto Díaz",
    address: "Calle Falsa 123",
    city: "La Cisterna",
    phoneNumber: "(9) 4840 7341",
    products: [
      {
        prodID: "g23234r24g",
        product_name: "Manga 20 kg Turbo Clean",
        variation: "Lavanda",
        quantity: 2,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "g23234r24g",
        product_name: "Manga 20 kg Turbo Clean",
        variation: "Manzana",
        quantity: 2,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "asoc3grh9o3",
        product_name: "1 saco 4 kg",
        variation: "Lavanda",
        quantity: 1,
        status: "not found", //  "not found" "multiple"
      },
    ],
    seller: "Super Michi",
    paymentInfo: [
      {
        paymentStatus: true,
        paymentMethod: "Tarjeta",
        paymentDate: undefined,
        amount: 14990,
      },
      {
        paymentStatus: false,
        paymentMethod: "Efectivo",
        paymentDate: new Date("2024-03-03"),
        amount: 10000,
      },
    ],
    orderAmount: 24990,
    deliveryInfo: [
      {
        deliveryStatus: false, // Si el pedido se entregó o no
        driver: "Rodrigo",
        deliveryDate: new Date("2024-03-03"),
        deliveryNote: "No hay nadie desde las 15:00 en adelante",
      },
      {
        deliveryNumber: 2,
        deliveryStatus: false, // Si el pedido se entregó o no
        driver: "Rodrigo",
        deliveryDate: new Date("2024-03-04"),
        deliveryNote: "No hay nadie desde las 15:00 en adelante",
      },
    ],
  },
  {
    order_id: "62",
    created_at: "2024-05-26T21:09:12.202Z",
    orderSource: "Whatsapp",
    messageRaw:
      "1 \n 05-05 \n Natalia Jimenez \n Pasaje Lago Cochranne 110 \n San Bernardo \n 945828542 \n * 40 kg trubo clean - lavanda \n * 40 kg trubo clean - manzana \n 24990 \n Tarjeta \n Super Michi \n No hay nadie desde las 15:00 en adelante",
    daily_id: "11057",
    name: "Natalia Jimenez",
    address: "Pasaje Lago Cochranne 110",
    city: "San Bernardo",
    phoneNumber: "(9) 4582 8542",
    products: [
      {
        prodID: "g23234r24g",
        product_name: "Turbo Clean",
        variation: "Lavanda",
        quantity: 10,
        status: "ok", //  "not found" "multiple"
      },
    ],
    seller: "Empresa",
    paymentInfo: [
      {
        paymentStatus: true,
        paymentMethod: "Tarjeta",
        paymentDate: new Date("2024-03-03"),
        amount: 14990,
      },
    ],
    orderAmount: 24990,
    deliveryInfo: [
      {
        deliveryStatus: true, // Si el pedido se entregó o no
        driver: "Rodrigo",
        deliveryDate: new Date("2024-03-03"),
        deliveryNote: "No hay nadie desde las 15:00 en adelante",
      },
    ],
  },
  {
    order_id: "63",
    created_at: "2024-05-26T21:09:12.202Z",
    orderSource: "Whatsapp",
    messageRaw:
      "1 \n 05-05 \n Natalia Jimenez \n Pasaje Lago Cochranne 110 \n San Bernardo \n 945828542 \n * 40 kg trubo clean - lavanda \n * 40 kg trubo clean - manzana \n 24990 \n Tarjeta \n Super Michi \n No hay nadie desde las 15:00 en adelante",
    daily_id: "11057",
    name: "Natalia Jimenez",
    address: "Pasaje Lago Cochranne 110",
    city: "San Bernardo",
    phoneNumber: "(9) 4582 8542",
    products: [
      {
        prodID: "g23234r24g",
        product_name: "Turbo Clean",
        variation: "Lavanda",
        quantity: 10,
        status: "ok", //  "not found" "multiple"
      },
    ],
    seller: "Empresa",
    paymentInfo: [
      {
        paymentStatus: true,
        paymentMethod: "Tarjeta",
        paymentDate: new Date("2024-03-03"),
        amount: 14990,
      },
    ],
    orderAmount: 24990,
    deliveryInfo: [
      {
        deliveryStatus: true, // Si el pedido se entregó o no
        driver: "Rodrigo",
        deliveryDate: new Date("2024-03-03"),
        deliveryNote: "No hay nadie desde las 15:00 en adelante",
      },
    ],
  },
  {
    order_id: "64",
    created_at: "2024-05-26T21:09:12.202Z",
    orderSource: "Whatsapp",
    messageRaw:
      "9 \n Ricardo González \n Gran Avenida 123 \n La Cisterna \n 945828542 \n * 20 kg miniino - lavanda \n * 40 kg tuboclean - manzana \n * 20 kg esy clen - manzana \n 52980 \n Tarjeat \n Empress \n *Dejar pedido en conserjería*",
    daily_id: "9",
    name: "Ricardo González",
    address: "Gran Avenida 123",
    city: "La Cisterna",
    phoneNumber: "(9) 4582 8542",
    products: [
      {
        prodID: "g23234r24g",
        product_name: "Manga 20 kg Minino",
        variation: "Lavanda",
        quantity: 1,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "fr9238rh7f",
        product_name: "Manga 20 kg Turbo Clean",
        variation: "Manzana",
        quantity: 2,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "g23234r24g",
        product_name: "Saco 20 kg Easy Clean",
        variation: "Manzana",
        quantity: 1,
        status: "ok", //  "not found" "multiple"
      },
    ],
    seller: "Empresa",
    paymentInfo: [
      {
        paymentStatus: false,
        paymentMethod: "Tarjeta",
        paymentDate: undefined,
        amount: 52980,
      },
    ],
    orderAmount: 52980,
    deliveryInfo: [
      {
        deliveryStatus: false, // Si el pedido se entregó o no
        driver: "No asignado",
        deliveryDate: undefined,
        deliveryNote: "*Dejar pedido en conserjería*",
      },
    ],
  },
  {
    order_id: "65",
    created_at: "2024-06-01T21:09:12.202Z",
    orderSource: "Whatsapp",
    messageRaw:
      "9 \n Ricardo González \n Gran Avenida 123 \n La Cisterna \n 945828542 \n * 20 kg miniino - lavanda \n * 40 kg tuboclean - manzana \n * 1 saco easy clean 4kg lavanda \n 52980 \n Tarjeat \n Empress \n *Dejar pedido en conserjería*",
    daily_id: "9",
    name: "Ricardo González",
    address: "Gran Avenida 123",
    city: "La Cisterna",
    phoneNumber: "(9) 4582 8542",
    products: [
      {
        prodID: "g23234r24g",
        product_name: "Manga 20 kg Minino",
        variation: "Lavanda",
        quantity: 1,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "fr9238rh7f",
        product_name: "Manga 20 kg Turbo Clean",
        variation: "Manzana",
        quantity: 2,
        status: "ok", //  "not found" "multiple"
      },
      {
        prodID: "g23234r24g",
        product_name: "1 saco easy clean 4kg lavanda",
        variation: "",
        quantity: 1,
        status: "not found", //  "not found" "multiple"
      },
    ],
    seller: "Empresa",
    paymentInfo: [
      {
        paymentStatus: false,
        paymentMethod: "Tarjeta",
        paymentDate: undefined,
        amount: 52980,
      },
    ],
    orderAmount: 52980,
    deliveryInfo: [
      {
        deliveryStatus: false, // Si el pedido se entregó o no
        driver: "No asignado",
        deliveryDate: undefined,
        deliveryNote: "*Dejar pedido en conserjería*",
      },
    ],
  },
];
